import { getTimeZone } from "../utils/Utils";

let dbTimezone = null;

export const setDbTimezone = (tz) => {
  dbTimezone = tz;
};

export const getDbTimezone = () => {
  return dbTimezone || getTimeZone(); // remove getTimeZone on stable.
};
